import React, { Component } from "react";
import { connect } from "react-redux";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { Button, Modal, Card, Table, message } from "antd";
import { usrRole } from "../../utils/dataUtil";

import {
  req_page_cslc_myparticipant,
  req_delete_cslc_myparticipant,
  req_single_people,
} from "../../api";

import MyParticipantRegisterAddModal from "./my-participant-register-add-modal";
import MyParticipantRegisterEditModal from "./my-participant-register-edit-modal";
import MyParticipantFileAEditModal from "./my-participant-register-edit-file-a-modal";
import MyParticipantFileBEditModal from "./my-participant-register-edit-file-b-modal";
import MyParticipantFileCEditModal from "./my-participant-register-edit-file-c-modal";
import MyParticipantWorksBrowseModal from "./my-participant-works-browse-modal";

class MyParticipantRegisterList extends Component {
  state = {
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    student: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",
    isShowModal: false,
    isAddModal: false,
    isEditModal: false,
    isShowFileAModal: false,
    isShowFileBModal: false,
    isShowFileCModal: false,
    isShowWorksModal: false,
    BeenRegistrationStatus: false,
    EditableStatus: true,
  };

  UNSAFE_componentWillMount() {
    this.api_people_info();
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, userCode, role } = this.props.user;

    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_cslc_myparticipant(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };

      this.setState({ items, pagination, BeenRegistrationStatus: true });
      console.log(items);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, BeenRegistrationStatus: false });
    }
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_delete_cslc_myparticipant(key, token);

    if (result.status === "success") {
      message.success("報名取消");
      this.api_page_items(this.current);
    } else {
      //console.log(result)
    }
  };

  api_people_info = async () => {
    const { token, userCode } = this.props.user;
    const student = await req_single_people(userCode, token);
    this.setState({ student });
    //console.log(student);
  };

  // 數據配置設定 //////////////////////////////////////////////
  init_columns = () => {
    this.columns = [
      {
        title: "報名者",
        dataIndex: "EnrollName",
        width: 20,
        responsive: ["md"],
      },
      {
        title: "角色名稱",
        dataIndex: "Title",
        width: 40,
        responsive: ["md"],
      },
      {
        title: "報名資訊",
        width: 40,
        fixed: "right",
        render: (item) => {
          const {
            EditableStatus,
            AttachedfileA,
            AttachedfileB,
            AttachedfileC,
          } = item;
          return (
            <>
              {EditableStatus === "OPEN" ? (
                <>
                  <button
                    type="button"
                    className="btn btn-outline-dark btn-sm"
                    onClick={() => this.handle_show_ui_modal("delete", item)}
                  >
                    <i className="fas fa-trash-alt"></i>
                    <span style={{ marginLeft: "4px" }}>刪除</span>
                  </button>
                  <button
                    type="button"
                    className="btn btn-outline-dark btn-sm"
                    onClick={() => this.handle_show_ui_modal("edit", item)}
                  >
                    <i className="fa fa-cog"></i>
                    <span style={{ marginLeft: "4px" }}>編輯</span>
                  </button>
                  <button
                    type="button"
                    className={
                      AttachedfileA === ""
                        ? "btn btn-outline-danger btn-sm"
                        : "btn btn-outline-dark btn-sm"
                    }
                    onClick={() => this.handle_show_ui_modal("FILEA", item)}
                  >
                    <i class="fa fa-upload"></i>
                    <span style={{ marginLeft: "4px" }}>上傳[全身立繪]</span>
                  </button>
                  <button
                    type="button"
                    className={
                      AttachedfileB === ""
                        ? "btn btn-outline-danger btn-sm"
                        : "btn btn-outline-dark btn-sm"
                    }
                    onClick={() => this.handle_show_ui_modal("FILEB", item)}
                  >
                    <i className="fa fa-upload"></i>
                    <span style={{ marginLeft: "4px" }}>上傳[角色Q版]</span>
                  </button>
                  <button
                    type="button"
                    className={
                      AttachedfileC === ""
                        ? "btn btn-outline-danger btn-sm"
                        : "btn btn-outline-dark btn-sm"
                    }
                    onClick={() => this.handle_show_ui_modal("FILEC", item)}
                  >
                    <i className="fa fa-upload"></i>
                    <span style={{ marginLeft: "4px" }}>
                      上傳[著作權切結書]
                    </span>
                  </button>
                </>
              ) : (
                <></>
              )}

              <button
                type="button"
                className="btn btn-outline-success btn-sm"
                onClick={() => this.handle_show_ui_modal("BROWSE", item)}
              >
                <i className="fa fa-eye" aria-hidden="true"></i>
                <span style={{ marginLeft: "4px" }}>瀏覽成果</span>
              </button>
            </>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "view":
        this.setState({ isShowModal: true, item });
        // this.api_add_view_log(item)
        break;
      case "edit":
        this.setState({ isEditModal: true, item });
        break;
      case "add":
        this.setState({ isAddModal: true });
        break;
      case "FILEA":
        this.setState({ isShowFileAModal: true, item });
        break;
      case "FILEB":
        this.setState({ isShowFileBModal: true, item });
        break;
      case "FILEC":
        this.setState({ isShowFileCModal: true, item });
        break;
      case "delete":
        const { Uid } = item;
        Modal.confirm({
          title: `您確定註銷報名`,
          onOk: () => {
            this.api_delete_item(Uid);
          },
        });
        break;
      case "BROWSE":
        this.setState({ isShowWorksModal: true, item });
        break;

      case "download":
        break;
      default:
    }
  };

  /////////////////////////////////////////////////////////////
  render() {
    const {
      items,
      item,
      pagination,
      isAddModal,
      isEditModal,
      isShowFileAModal,
      isShowFileBModal,
      isShowFileCModal,
      isShowWorksModal,
      BeenRegistrationStatus,
      student,
    } = this.state;
    const title = (
      <div>
        {BeenRegistrationStatus ? (
          ""
        ) : (
          <div style={{ textAlign: "center" }}>
            <Button
              type="primary"
              icon={<i className="fas fa-plus"></i>}
              onClick={() => this.handle_show_ui_modal("add", student)}
            >
              <span style={{ marginLeft: "4px" }}>我要報名</span>
            </Button>
            <p />
          </div>
        )}
      </div>
    );
    return (
      <>
        {title}
        <Card>
          {BeenRegistrationStatus ? (
            <>
              <Table
                bordered
                scroll={{ y: 480 }}
                rowKey="Uid"
                dataSource={items}
                onChange={this.handle_table_change}
                pagination={{
                  ...pagination,
                  responsive: true,
                  showQuickJumper: true,
                  showSizeChanger: true,
                  pageSizeOptions: [5, 10, 20, 50, 100],
                  // onChange: this.api_page_applycase,
                  onShowSizeChange: this.handle_page_size_change,
                }}
                columns={this.columns}
              />
            </>
          ) : (
            ""
          )}
          <Modal
            destroyOnClose={true}
            visible={isAddModal}
            width={"90%"}
            onOk={() => {
              this.setState({ isAddModal: false });
              this.handle_data_refresh();
            }}
            okText={"關閉"}
            onCancel={() => {
              this.setState({ isAddModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <MyParticipantRegisterAddModal participant={student} />
          </Modal>
          <Modal
            destroyOnClose={true}
            visible={isEditModal}
            width={"90%"}
            onOk={() => {
              this.setState({ isEditModal: false });
              this.handle_data_refresh();
            }}
            okText={"關閉"}
            onCancel={() => {
              this.setState({ isEditModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <MyParticipantRegisterEditModal participant={item} />
          </Modal>
          <Modal
            destroyOnClose={true}
            visible={isShowFileAModal}
            width={"450px"}
            onOk={() => {
              this.setState({ isShowFileAModal: false });
              this.handle_data_refresh();
            }}
            okText={"關閉"}
            onCancel={() => {
              this.setState({ isShowFileAModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <MyParticipantFileAEditModal
              participant={item}
              fileTarget={"FILEA"}
            />
          </Modal>
          <Modal
            destroyOnClose={true}
            visible={isShowFileBModal}
            width={"450px"}
            onOk={() => {
              this.setState({ isShowFileBModal: false });
              this.handle_data_refresh();
            }}
            okText={"關閉"}
            onCancel={() => {
              this.setState({ isShowFileBModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <MyParticipantFileBEditModal
              participant={item}
              fileTarget={"FILEB"}
            />
          </Modal>
          <Modal
            destroyOnClose={true}
            visible={isShowFileCModal}
            width={"450px"}
            onOk={() => {
              this.setState({ isShowFileCModal: false });
              this.handle_data_refresh();
            }}
            okText={"關閉"}
            onCancel={() => {
              this.setState({ isShowFileCModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <MyParticipantFileCEditModal
              participant={item}
              fileTarget={"FILEC"}
            />
          </Modal>
          <Modal
            destroyOnClose={true}
            visible={isShowWorksModal}
            width={"500px"}
            onOk={() => {
              this.setState({ isShowWorksModal: false });
            }}
            okText={"關閉"}
            onCancel={() => {
              this.setState({ isShowWorksModal: false });
            }}
            cancelButtonProps={{ style: { display: "none" } }}
          >
            <MyParticipantWorksBrowseModal participant={item} />
          </Modal>
        </Card>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(MyParticipantRegisterList);
